import { useEffect, useMemo, useState } from 'react';
import { RadioGroup, SvgIconProps } from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
    InsertPhotoOutlined as InsertPhotoOutlinedIcon,
    LiveTv as LiveTvIcon,
    MusicNoteOutlined as MusicNoteOutlinedIcon,
    OndemandVideo as OndemandVideoIcon,
    Subscriptions as SubscriptionsIcon,
} from '@mui/icons-material';

import { RadioCard, RadioCardGroupProps } from '../../../components/RadioCard';

import { Code } from '../../../types/Code';
import { useCodeList } from '../../../hooks/Models/CodeList';

type CampaignMediaTypeRadioGroupProps = {
    filter?(codes: Code[]): Code[];
} & RadioCardGroupProps;

export default function CampaignMediaTypeRadioGroup(props: CampaignMediaTypeRadioGroupProps) {
    const { disabled, filter, ...radioGroupProps } = props;
    const [filteredCodes, setFilteredCodes] = useState<Code[]>([]);
    const { codes, defaultCode } = useCodeList({ codeGroup: 'MediaType' });

    const defaultValue = useMemo(() => {
        return defaultCode ? defaultCode.code : '';
    }, [defaultCode]);

    useEffect(() => {
        if (codes && codes.length > 0) {
            setFilteredCodes(filter ? filter(codes) : codes);
        } else {
            setFilteredCodes([]);
        }
    }, [codes, filter]);

    const getCodeIcon = (code: Code): React.ComponentType<SvgIconProps> | undefined => {
        switch (code.code) {
            case 'Display':
                return InsertPhotoOutlinedIcon;

            // case 'Blended Video':
            case 'Video':
                return SubscriptionsIcon;

            case 'Online Video':
            case 'OLV':
                return OndemandVideoIcon;

            case 'Streaming TV':
            case 'TV':
            case 'STV':
                return LiveTvIcon;

            case 'Audio':
                return MusicNoteOutlinedIcon;
        }

        return undefined;
    };

    return (
        <RadioGroup defaultValue={defaultValue} {...radioGroupProps} value={props.value}>
            {filteredCodes && (
                <Grid container spacing={3}>
                    {filteredCodes.map((code: Code) => {
                        return (
                            <Grid key={code.code} size={3}>
                                <RadioCard
                                    direction="column"
                                    required={true}
                                    disabled={disabled}
                                    value={code.code}
                                    label={code.description}
                                    LabelIcon={getCodeIcon(code)}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            )}
        </RadioGroup>
    );
}
